import { FaVial } from "react-icons/fa";
import DropdownItemBase from "./DropdownItemBase";

const DropdownItemExame = ({ notif, onClick }) => {
    const info = notif.atendimento_info;
    if (!info) return null;

    let dataFormatada = info.data_criacao || "";
    if (dataFormatada && !dataFormatada.includes('/')) {
            try {
                dataFormatada = new Date(dataFormatada).toLocaleString("pt-BR");
            } catch (e) {}
    }

    return (
        <DropdownItemBase
            icon={<FaVial />}
            text="text-warning"
            titulo="Nova Solicitação de Exame"
            descricao={
                <>
                    Paciente: <strong>{info.beneficiario_nome}</strong>
                </>
            }
            subDescricao={`Programa: ${info.programa_nome}`}
            dataFormatada={dataFormatada}
            onClick={() => onClick(notif)}
        />
    );
};

export default DropdownItemExame;
